import axios from 'axios';

// Sucursales (propuesta integral Fase 0, doc 08 A.2: region y qr_token).
export default {
  getAll() {
    return axios.get('/sucursals');
  },

  // El backend recibe el objeto completo (PUT /{tenant}/sucursal con id en el body).
  update(data) {
    return axios.put('/sucursal', data);
  },

  // Regenera y persiste el token del QR de descarga de inmediato (Fase 4).
  regenerateQr(sucursalId) {
    return axios.post(`/sucursal/${sucursalId}/qr/regenerate`);
  }
}
